module.exports = __webpack_public_path__ + "static/img/Property-left.3d19ef3b.svg";